export const geometry = [
  {
    x: 300,
    y: 470,
    width: 680,
    height: 300,
  },
  {
    x: 100,
    y: 700,
    width: 1080,
    height: 20,
  },
  {
    x: 150,
    y: 550,
    width: 200,
    height: 20,
  },
  {
    x: 930,
    y: 550,
    width: 200,
    height: 20,
  },
  {
    x: 540,
    y: 610,
    width: 200,
    height: 20,
  },
];
